import React, { createContext, useEffect, useReducer } from "react";
import Reducer from "./reducer";
import { initialState } from "./initialState";
import { fetchInvoices } from "./service";
const Context = createContext();
const Provider = ({ children }) => {
    const [state, dispatch] = useReducer(Reducer, initialState);
    useEffect(() => {
        const getData = async () => {
            try{
                dispatch({ type: 'IS_LOADING' });
                const response = await fetchInvoices(state.current_page, state.serach_text, state.sort_key, state.sort_direction);
                dispatch({ 
                    type: "IS_LOADED", 
                    job_invoices: response.job_invoices, 
                    total_invoices: response.total_invoices, 
                    total_pages: response.total_pages, 
                });
            } catch (error) {
                console.log(error);
            }
        };
        getData();
    }, [state.current_page, state.serach_text, state.sort_key, state.sort_direction]);
    
    return (
        <Context.Provider value={{state, dispatch}}>
            {children}
        </Context.Provider>
    )
}
export { Context, Provider };